export enum ConfiguracionVehicularSigoEnum 
{
    TractoCamabaja = 1,
    TractoDollyCamabaja = 2,
    TractoModular = 3,
    TractoDollyModular = 4,
    TractoPlataforma = 5,
    TractoCiguena = 6,
    TractoRemolque1EjeDelantero = 7,
    TractoRemolque2EjeDelantero = 8,
    TractoRemolqueEjesMultiples = 9,
    TractoCamion = 10,
}

export enum TipoEngancheModularSigoEnum 
{
    Semiremolque = 1,
    Remolque = 2    
}